// extracted by mini-css-extract-plugin
module.exports = {"mobile":"styles-module--mobile--2vgPq","desktop":"styles-module--desktop--bcaYe"};